import { MiscUtil, mergeConfig, merge2Obj } from '@/utils/miscUtil'
import Axios from 'axios'

import HttpRequest from "@/utils/axios";

function getHttpRequest() {
    if (process.env.NODE_ENV !== 'production') {
        return new HttpRequest('/home')
    } else {
        let href = window.location.href;
        href = href.split('/ztdt')[0];
        console.log(href, '请求首页配置')
        return new HttpRequest(href)
    }
}

const Config = {
    /**
     * 基础配置信息项
     */
    baseConfig: {
        templateJson: {},
        poiConf: null,
        markConf: null,
        analysisConf: null,
        carConf: null,
        busConf: null,
        fontConf: null,
        centerConf: null,
        wrongSrvConf: null,
        extractionConf: null,
        waterConf: null,
        rainConf: null,
        surfaceWaterConf: null,
        airConf: null,
        pollutionConf: null,
        goladminService: null,
        gardenWFSConf: null,
        greenWFSConf: null,
        airPointWFSConf: null,
        userConf: null
    },
    /**
     * 基础配置项
     */
    async initSysConfigs() {
        try {
           return MiscUtil.fetch('admin/mapFront/querySysConfigs').then(sysConfigs => {
                const sysConfig = {}
                sysConfigs.forEach(conf => {
                    const { name, value } = conf
                    sysConfig[name] = value
                })
                return mergeConfig(sysConfig, this.baseConfig)
            })
            /*let tempTask = {
                centerConf:{
                    lat: 26.635627,
                    lon: 118.178459,
                    name: "南平市",
                    zoom: 8
                }
            }
            return mergeConfig(tempTask, this.baseConfig)*/
        } catch (e) {
            throw "基础配置读取错误"
        }
    },

    async getHomeConfig() {
        let url = "/mapConfig/getAllMapConfig"
        return getHttpRequest().request({
            url,
            method: "post",
        }).then((res) => {
            let data = {}
            if (res.data.success) {
                res.data.data.forEach(res => {
                    data[res.configName] = res.configValue
                })
            }
            return data
        });
    },

    /**
     * @method initOutConfig
     * 初始化外部配置
     */
    async initOutConfig() {
        const configAnalysis = async url => {
            return Axios.get(url, { responseType: 'text' }).then(({ data }) => {
                const config = eval(`(function(){${data}})()`)
                return config
            })
        }

        return configAnalysis('./config/config.js').then(config => {
            let active = config.active,
                url
            delete config.active

            if (!active) {
                active = process.env.NODE_ENV === 'development' ? 'dev' : 'prod'
            }
            url = `./config/config.${active}.js`

            return configAnalysis(url)
                .then(cconfig => {
                    return merge2Obj(config, cconfig)
                })
                .catch(() => {
                    console.error('getConfig:', 'can not find' + url)
                    return config
                })
        })
    }
}

/**
 * @api
 * 请求配置文件
 */
export async function initConfig() {
    return Config.initOutConfig().then(async outConfig => {
        Config.baseConfig.goladminService = outConfig.goladminService
        Config.baseConfig.shareTaskApp = outConfig.shareTaskApp
        Config.baseConfig.usersystemProxy = outConfig.usersystemProxy
        console.log('outConfig:', outConfig)

        // 设置path
        MiscUtil.appPath = outConfig.appPath
        MiscUtil.proxyUrl = outConfig.proxyUrl
        // 设置proxy
        // GeoGlobe.ProxyHost = MiscUtil.getProxyUrl();
        console.log(GeoGlobe.ProxyHost, 'GeoGlobe.ProxyHost')


        // let user = await new Promise((resolve, reject) => {
        //     MiscUtil.getDSWithPorxy('user/getUserInfo').then(data => {
        //         resolve(data);
        //     })
        // })
        let user = ''

        // 其他后台配置请求
        const [datas, HomeConfig] = await Promise.all([
            Config.initSysConfigs(),
            Config.getHomeConfig()
        ])
        datas.userConf = user
        datas.templateJson = {}
        const config = Object.assign({}, outConfig, datas, HomeConfig)
        console.log(config,"返回前")

        return [config, null]
    })
}
